module.exports = __webpack_public_path__ + "img/cutlery.jpg.1d64d17b.webp";